// extracted by mini-css-extract-plugin
export var bodyRow = "_fu-d";
export var cardColumns = "_fu-e";
export var ellipsesOverflow = "_fu-2";
export var flatBottomCorners = "_fu-3";
export var flatTopCorners = "_fu-4";
export var headerActionsDropdown = "_fu-f";
export var headerBottomRow = "_fu-c";
export var headerTopRow = "_fu-b";
export var orderDetailsWrapper = "_fu-0";
export var orderInfoContainer = "_fu-1";
export var productDetails = "_fu-9";
export var productImage = "_fu-5";
export var responsiveTable = "_fu-8";
export var shipmentContainer = "_fu-a";
export var tableBottomLeft = "_fu-6";
export var tableBottomRight = "_fu-7";